import jwtDecode from "jwt-decode";
import config from "../../config";

class JwtUtils {
  getEmail() {
    return jwtDecode(localStorage.authToken).sub;
  }

  isActif() {
    if (localStorage.authToken) {
      let decoded = jwtDecode(localStorage.authToken);
      return decoded?.isActif;
    }
    return false;
  }

  isTokenValidAndNotExpired() {
    try {
      let decoded = jwtDecode(localStorage.authToken, config.jwtSecret);
      if (Date.now() >= decoded.exp * 1000) {
        return false;
      }
      return true;
    } catch (err) {
      return false;
    }
  }
  isExpired() {
    let decoded = jwtDecode(localStorage.authToken);
    if (Date.now() >= decoded.exp * 1000) {
      return true;
    }
    return false;
  }

  hasAnyRole(rolesIn) {
    if (rolesIn.length === 0) {
      return true;
    }
    if (!localStorage.authToken) {
      return false;
    }
    let currentRoles = jwtDecode(localStorage.authToken)?.roles ?? [];
    localStorage.setItem("roles", currentRoles);
    const found = rolesIn.some((r) => currentRoles.indexOf(r) >= 0);
    return found;
  }

  logOutWithoutRefresh() {
    localStorage.authToken && localStorage.removeItem("authToken");
  }

  logOut() {
    if (localStorage.authToken) {
      localStorage.removeItem("authToken");
      window.location.reload();
    }
  }
}

export default new JwtUtils();
